var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-success-thank-you-green.8e55e50c.png","uri@2x": __webpack_public_path__ + "icon-success-thank-you-green.ebf2a841.png","uri@3x": __webpack_public_path__ + "icon-success-thank-you-green.fe84cbca.png",
    width: 200,
    height: 200
});